//#region Modules
import * as React from "react";
import type { IAnalytics } from "@anydo/analytics";
import { AnalyticsContext } from "./-private/AnalyticsContext";
import type { IAnalyticsContextValue } from "./IAnalyticsContextValue";
//#endregion

//#region Types
interface IProps {
  analytics: IAnalytics;
  children: React.ReactNode;
}
//#endregion

export function AnalyticsProvider({ analytics, children }: IProps) {
  const contextValue = React.useMemo((): IAnalyticsContextValue => {
    const utms = analytics.getUtms();
    const utm_source = utms.get("utm_source");

    return {
      UTM: {
        source: utm_source == null ? null : utm_source,
      },
      track: analytics.track.bind(analytics),
    };
  }, [analytics]);

  return <AnalyticsContext.Provider value={contextValue}>{children}</AnalyticsContext.Provider>;
}
